import type { FC } from 'react';
import Projects from '@/pages/Projects';
import ProjectsLegacy from '@/pages/ProjectsLegacy';
import { FF_PROJECTS_V2, useFeatureFlag } from '@/hooks/useFeatureFlag';

const ProjectsListRoute: FC = () => {
    const { enabled: isProjectsV2Enabled, isResolved } =
        useFeatureFlag(FF_PROJECTS_V2);

    if (!isResolved) {
        return;
    }

    return isProjectsV2Enabled ? <Projects /> : <ProjectsLegacy />;
};

export default ProjectsListRoute;
